<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="el-dialog-sm"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="ladingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              付款方信息
            </h3>
            <div class="modal-row-box">
              <el-row>
                <el-col :span="24">
                  <el-form-item
                    v-if="eventType!=='view'"
                    label="省区"
                    prop="provinceId"
                  >
                    <el-select
                      v-model="dialogAddEditViewForm.provinceId"
                      filterable
                      clearable
                      placeholder="请选择省区"
                      style="width:100%"
                      @change="changeProvinceFun"
                    >
                      <el-option
                        v-for="item in provinceOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-else
                    label="省区"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    v-if="eventType!=='view'"
                    label="城市"
                    prop="cityId"
                  >
                    <el-select
                      v-model="dialogAddEditViewForm.cityId"
                      filterable
                      clearable
                      placeholder="请选择城市"
                      style="width:100%"
                      @change="cityChangeFun"
                    >
                      <el-option
                        v-for="item in cityOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-else
                    label="城市"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="名称"
                    prop="name"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.name"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="银行名称"
                    prop="bankName"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.bankName"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="银行账号"
                    prop="bankNo"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.bankNo"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { loadAreaDataApi } from '@/api/area'
import { initPayerApi, saveOrUpdatePayerApi } from '@/api/payerSetting'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      ladingText: '努力加载数据中，请耐心等待',

      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        provinceId: [{ required: true, message: '请选择省区', trigger: 'change' }],
        cityId: [{ required: true, message: '请选择城市', trigger: 'change' }],
        name: [{ required: true, message: '请输入付款方名称', trigger: 'blur' }, { max: 128, message: '最多输入128个字符', trigger: 'blur' }],
        bankName: [{ max: 200, message: '最多输入200个字符', trigger: 'blur' }],
        bankNo: [{ max: 64, message: '最多输入64个字符', trigger: 'blur' }]
      },
      provinceOptions: [],
      cityOptions: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.loading = true
        this.loadingText = '努力加载数据中，请耐心等待'

        this.dialogAddEditViewForm = {
          provinceId: '',
          provinceName: '',
          cityId: '',
          cityName: '',
          name: '',
          bankName: '',
          bankNo: '',
          status: 1
        }
        this.provinceOptions = []
        this.cityOptions = []

        this.initProvinceData()
        if (this.eventType !== 'add') {
          this.initPageData()
        }

        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    initPageData () {
      initPayerApi({ id: this.dataId }).then(response => {
        const { data } = response
        for (let key in this.dialogAddEditViewForm) {
          this.dialogAddEditViewForm[key] = data[key]
        }
        this.dialogAddEditViewForm.id = data.id
        this.initCityData(data.provinceId)
        this.loading = false
      })
    },
    // 初始省区下拉数据
    initProvinceData () {
      loadAreaDataApi({ parentId: 1, isUserArea: 1 }).then(res => {
        res.data.forEach(item => {
          this.provinceOptions.push({ label: item.name, value: item.id })
        })

        if (this.eventType === 'add') this.loading = false
      })
    },
    // 选择省区回调
    changeProvinceFun (val) {
      let selectItem = {}
      selectItem = this.provinceOptions.find(item => {
        return item.value === val
      })
      this.dialogAddEditViewForm.provinceName = selectItem ? selectItem.label : ''
      this.cityOptions = []
      this.dialogAddEditViewForm.cityName = ''
      this.dialogAddEditViewForm.cityId = ''
      if (val) {
        this.initCityData(val)
      }
    },
    // 初始城市下拉数据
    initCityData (val) {
      loadAreaDataApi({ parentId: val, isUserArea: 1 }).then(res => {
        res.data.forEach(item => {
          this.cityOptions.push({ label: item.name, value: item.id })
        })
      })
    },
    // 选择城市回调
    cityChangeFun (val) {
      let selectItem = {}
      selectItem = this.cityOptions.find(item => {
        return item.value === val
      })
      this.dialogAddEditViewForm.cityName = selectItem ? selectItem.label : ''
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '物料品牌', '系统提示',
            { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
          ).then(async () => {
            this.loading = true
            this.loadingText = '正在保存数据中'

            saveOrUpdatePayerApi(this.dialogAddEditViewForm).then(res => {
              if (res.mark === '200') {
                this.$message({ message: res.message, type: 'success' })
                this.reloadData()
                this.modalClose()
              }
            }).catch(() => {
              this.loading = false
            })
          }).catch(() => { })
        }
      })
    },
  }
}
</script>
<style lang="scss"  scoped>
</style>
